import { isOverseasVersion } from 'common-module/src/util';
import {
  queryLastOrderDetail,
  queryOrgRightRule,
  checkEightExisted
} from 'common-module/src/api/price';

const state = {
  lastOrderInfo: null,
  productRight: {},
  checkRight: {}
};

const getters = {};

const mutations = {
  SET_LAST_ORDER_INFO: (state, info) => {
    state.lastOrderInfo = info;
  },
  SET_RIGHT_ITEM: (state, { key, value }) => {
    state.productRight[key] = value;
  },
  SET_CHECK_RIGHT: (state, { key, value }) => {
    state.checkRight[key] = value;
  }
};

const actions = {
  // 国内版查询最后一笔订单权益
  async getLastOrderInfo({ commit }) {
    if (isOverseasVersion) {
      return;
    }
    const res = await queryLastOrderDetail();
    commit('SET_LAST_ORDER_INFO', res);
  },
  reset({ commit }) {
    commit('SET_LAST_ORDER_INFO', null);
  },

  /**
   * 获取组织当前的某项权益
   * @param {string} rightType
   * @param {string} key 用于直接获取某个权益的值，非必填
   */
  async getOrgRight({ commit }, { rightType, key }) {
    const result = await queryOrgRightRule({ rightType });
    commit('SET_RIGHT_ITEM', { key: rightType, value: result });

    if (!result) {
      return null;
    }
    return key ? result[key] : result;
  },

  /*
  * 检测某项权益是否可用
  * memberNum 席位
  * storageNum 存储空间
  * customFieldNum 字段
  * automationActionNum 智能助理
  * aiCredit AI权益
  */
  async checkRight({ commit }, { rightType }) {
    const result = await checkEightExisted({ rightType });
    commit('SET_CHECK_RIGHT', { key: rightType, value: result });
    return result;
  },
  // 检测AI权益是否可用
  checkAiRight({ dispatch }) {
    return dispatch('checkRight', { rightType: 'aiCredit' });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
